import { Component, OnInit } from "@angular/core";
import { ApiHandlerService } from "../../shared/services/api-handler.service";
import { ToasterService } from "../../shared/services/toaster.service";
import { CmnFunctionService } from "../../shared/services/cmn-function.service";
import { StorageService } from "../../shared/services/storage.service";
import { Router } from "@angular/router";
import { SocketService } from "src/app/shared/services/socket.service";
declare let swal: any;
@Component({
  selector: "app-inner-header",
  templateUrl: "./inner-header.component.html",
  styleUrls: ["./inner-header.component.scss"],
})
export class InnerHeaderComponent implements OnInit {
  public currentUseInfo: any = {};
  constructor(
    public service: ApiHandlerService,
    public toaster: ToasterService,
    public storage: StorageService,
    public cmnFunction: CmnFunctionService,
    public router: Router,
    public socket: SocketService
  ) {}

  ngOnInit() {
    this.cmnFunction.userInfo.subscribe((data) => {
      if (data) {
        console.log(data);
        this.currentUseInfo.name = data.name;
        this.currentUseInfo.image = data.image;
        this.currentUseInfo.role = data.role;
        this.currentUseInfo.unreadNotification = data.unreadNotification;
      } else {
        if (JSON.parse(localStorage.getItem("userData")) != null) {
          this.currentUseInfo.name = JSON.parse(
            localStorage.getItem("userData")
          ).name;
          this.currentUseInfo.image = JSON.parse(
            localStorage.getItem("userData")
          ).image;
          this.currentUseInfo.role = JSON.parse(
            localStorage.getItem("userData")
          ).role;
          this.currentUseInfo.unreadNotification = JSON.parse(
            localStorage.getItem("userData")
          ).unreadNotification;
        }
      }
    });

    if(!this.socket.socket)this.socket.initSocket();
    this.socket.onEvent("notify").subscribe((result) => {
      if (result && result.text) {
        new Notification(result.text);
      }
      this.getUserDetails();
    });
    this.getUserDetails();
  }

  //LogoutUser function for logout user from app..
  LogoutUser() {
    swal({
      title: "Are you sure you want to logout?",
      text: "",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        //apiPost function for post data to Db...
        this.service.apiGet(this.service.baseUrl + "logout").subscribe({
          next: (result) => {
            if (result.status) {
              this.storage.deleteUserToken();
              this.storage.DeleteUserStorageData();
              this.toaster.Success(result.message);

              this.cmnFunction.userInfo.next(null);
              //redirect to cutomer page
              this.router.navigate(["auth/login"]);
            } else {
              this.toaster.Error(result.message);
              this.storage.deleteUserToken();
              this.storage.DeleteUserStorageData();
              this.router.navigate(["auth/login"]);
            }
          },
          error: (err) => {
            let msg =
              err.error && err.error.message
                ? err.error.message
                : "Invalid Credentials";
            //this.loginForm.reset();
            //this.toasterService.Error(msg);
            this.toaster.Error(msg);
            this.storage.deleteUserToken();
            this.storage.DeleteUserStorageData();
            this.router.navigate(["auth/login"]);
          },
          complete: () => {},
        });
      } else {
      }
    });
  }

  getUserDetails() {
    //apiPost function for post data to Db...
    this.cmnFunction.getUserDetails().subscribe((data) => {
      if (data) {
        this.currentUseInfo = data.data;
      }
    });
  }

  clickNotification() {
    //  debugger;
    //  let curruntUrl = this.router.url;
    //  if(curruntUrl.includes('/settings')){
    //     if(localStorage.getItem('currentTab') != null){
    //       if(localStorage.getItem('currentTab')!= '4'){
    //         window.location.reload();
    //       }
    //     }
    //   }
    localStorage.setItem("currentTab", <any>"4");
  }
}
